import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { OrganizationsService } from '../../../core/api/services/organizations.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'organization-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class OrganizationSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('type') type:
    | 'organizations'
    | 'descendantAndItselfList'
    | 'children'
    | 'childrenAndItselfList'
    | 'descendantList'
    | 'organizationForCreateUser'
    | 'currentResellerOrganization' = 'organizations';

  @Output('defaultValue') output_defaultValue = new EventEmitter<number>();

  constructor(protected currentService: OrganizationsService) {
    super();
  }

  initConfig() {
    super.initConfig();
    if (!this.label) this.label = 'common.organization';
  }
  override getItems(): void {
    this.getItemsApi();
  }

  getItemsApi() {
    switch (this.type) {
      // descendantAndItselfList
      case 'descendantAndItselfList':
        if (this.isAllowGetItems())
          this.currentService
            .organizationsGetOrganizationDescendantAndItselfList()
            .pipe(this.basePipeOperators())
            .subscribe({
              next: (items) => {
                this.items = items.data;
                this.output_defaultValue.emit(this.items[0][this.optionValue]);
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;
      // childrenAndItselfList
      case 'childrenAndItselfList':
        if (this.isAllowGetItems())
          this.currentService
            .organizationsGetOrganizationChildrenAndItselfList()
            .pipe(this.basePipeOperators())
            .subscribe({
              next: (items) => {
                this.items = items.data;
                this.output_defaultValue.emit(this.items[0][this.optionValue]);
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;
      // descendantList
      case 'descendantList':
        if (this.isAllowGetItems())
          this.currentService
            .organizationsGetOrganizationDescendantList()
            .pipe(this.basePipeOperators())
            .subscribe({
              next: (items) => {
                this.items = items.data;
                this.output_defaultValue.emit(this.items[0][this.optionValue]);
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;
      // organizationForCreateUser
      case 'organizationForCreateUser':
        if (this.isAllowGetItems())
          this.currentService
            .organizationsGetOrganizationForCreateUser()
            .pipe(this.basePipeOperators())
            .subscribe({
              next: (items) => {
                this.items = items.data;
                this.output_defaultValue.emit(this.items[0][this.optionValue]);
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;
      // currentResellerOrganization
      case 'currentResellerOrganization':
        if (this.isAllowGetItems())
          this.currentService
            .organizationsGetCurrentResellerOrganizationList()
            .pipe(this.basePipeOperators())
            .subscribe({
              next: (items) => {
                this.items = items.data;
                this.output_defaultValue.emit(this.items[0][this.optionValue]);
              },
              error: (error) => {
                this.emitError();
              },
            });
        break;
    }
  }

  //use in switch case
  isAllowGetItems(): boolean {
    if (this.initLoading) return false;
    this.isFetchData = false;
    this.initLoading = true;
    return true;
  }
}
